const removeClassName = (node, partialName) => {
	node.classList.forEach((className) => {
		return className.includes(partialName) ? node.classList.remove(className) : null;
	});
	return node;
};
const checkXPlace = (target, node) => {
	let xPosition = target.tooltipPosition;
	let checkRightNode = window.innerWidth - target.right >= parseInt(node.clientWidth);
	let checkLeftNode = target.left >= parseInt(node.clientWidth);
	node.classList.remove("tooltip-responsive");

	if (!(checkRightNode && checkLeftNode)) {
		if (checkRightNode) {
			xPosition = "right";
		} else if (checkLeftNode) {
			xPosition = "left";
		} else {
			node.classList.add("tooltip-responsive");
		}
	}

	return xPosition;
};

const checkYPlace = (target, node) => {
	let yPosition = target.position;
	let nodeBottomPosition = target.bottom + parseInt(node.clientHeight);
	if (nodeBottomPosition >= window.innerHeight) {
		yPosition = "top";
	}
	return yPosition;
};

const bottomTooltip = (target, node) => {
	let top = target.top + target.height + target.arrowHeight;
	let left = target.left;
	let xPlace = checkXPlace(target, node);
	if (xPlace === "left") {
		left = bottomLeftTooltip(target, node);
	} else if (xPlace === "right") {
		left = bottomRightTooltip(target, node);
	}
	return { top, left };
};
const topTooltip = (target, node) => {
	let top = target.top - node.clientHeight;
	let left = target.left;
	let xPlace = checkXPlace(target, node);
	if (xPlace === "left") {
		left = topLeftTooltip(target, node);
	} else if (xPlace === "right") {
		left = topRightTooltip(target, node);
	}
	return { top, left };
};

const bottomRightTooltip = (target, node) => {
	let left = target.left;
	let arrowPosition = target.width / 2;
	node.classList.add(`place-bottom`);
	node.classList.add(`arrow-bottom-${target.tooltipPosition}`);
	node.style.setProperty("--tooltip-position-left", `${left}px`);
	node.style.setProperty("--tooltip-arrow-position", `${arrowPosition}px`);
	return left;
};

const bottomLeftTooltip = (target, node) => {
	let left = target.right - node.offsetWidth;
	let right = window.innerWidth - target.right - node.offsetWidth / 2;
	let arrowPosition = node.offsetWidth - target.width / 2;
	node.classList.add(`place-bottom`);
	node.classList.add(`arrow-bottom-${target.tooltipPosition}`);
	node.style.setProperty("--tooltip-arrow-position", `${arrowPosition}px`);
	node.style.setProperty("--tooltip-position-right", `${right}px`);
	return left;
};
const topRightTooltip = (target, node) => {
	let left = target.left;
	let arrowPosition = target.width / 2;
	node.classList.add(`place-top`);
	node.classList.add(`arrow-top-${target.tooltipPosition}`);
	node.style.setProperty("--tooltip-position-left", `${left}px`);
	node.style.setProperty("--tooltip-arrow-position", `${arrowPosition}px`);
	return left;
};

const topLeftTooltip = (target, node) => {
	let left = target.right - node.offsetWidth;
	let arrowPosition = node.offsetWidth - target.width / 2 - 6;
	if (left <= 0) {
		left = 10;
		arrowPosition = target.left - target.width;
	}
	let right = window.innerWidth - target.right - node.offsetWidth / 2;
	node.classList.add(`place-top`);
	node.classList.add(`arrow-top-${target.tooltipPosition}`);
	node.style.setProperty("--tooltip-arrow-position", `${arrowPosition}px`);
	node.style.setProperty("--tooltip-position-right", `${right}px`);
	return left;
};

export const setPosition = (
	{ left, top },
	currentEvent,
	currentTarget,
	node,
	place,
	desiredPlace,
	effect,
	offset,
	position,
	tooltipPosition
) => {
	const target = currentTarget.querySelectorAll(".button-icon").length
		? currentTarget.querySelectorAll(".button-icon")[0]
		: currentTarget;
	const BoundingClientRect = target.getBoundingClientRect();
	const targetPosition = {
		left: BoundingClientRect.left,
		right: BoundingClientRect.right,
		top: BoundingClientRect.top,
		bottom: BoundingClientRect.bottom,
		height: target.clientHeight,
		width: target.clientWidth,
		arrowHeight: 10,
		position: position,
		tooltipPosition: tooltipPosition
	};
	let yPlace = checkYPlace(targetPosition, node);
	node = removeClassName(node, "place-");
	if (yPlace === "bottom") {
		return bottomTooltip(targetPosition, node);
	} else if (yPlace === "top") {
		return topTooltip(targetPosition, node);
	} else {
		return { top, left };
	}
};

export default {
	setPosition
};
